module.exports = __webpack_public_path__ + "img/DOXWEB.3324aeec.png";